<div class="fe-capacities-container">
  <div class="spinner-container" *ngIf="spinnerBoolean">
    <div class="spinner"></div>
    <div class="spinner-text">Loading Alternate Capacity data...</div>
  </div>

  <div class="table-actions-bar">
    <div class="table-title">Alternate Capacity Use</div>
    <button *ngIf="hasAnyFilterApplied()" (click)="clearAllFilters()">Clear All</button>
    <button *ngIf="selectedRows.length > 0" (click)="clearSelection()">Clear Select</button>
    <button *ngIf="showCancel" (click)="cancelRow()">Cancel</button>
    <button (click)="addRow()">New</button>
    <button (click)="handleSave()" [disabled]="!data.length">Save</button>
    <button (click)="handleDelete()" [disabled]="!selectedRows.length">Delete</button>
    <button (click)="openExportDialog()" [disabled]="!data.length">Export</button>
  </div>

  <div class="table-container" [ngClass]="{ hidden: spinnerBoolean }">
    <div class="table-header-container">
      <div class="table-header-row">
        <div class="table-header-cell fixed-width-cell-2">Select</div>
        <div class="table-header-cell" *ngFor="let col of columns">
          <div class="col-wrap">
            <div class="text-wrap">
              {{ col.header }}
              <span *ngIf="col.required" class="required-asterisk" title="Required">*</span>
            </div>
            <div class="filter-icon-container" *ngIf="col.filterable">
              <img
                class="filter-icon"
                [ngClass]="{ 'active-filter': isFilterActive(col.field) }"
                [src]="isFilterActive(col.field) ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                width="16"
                height="16"
                alt="Filter"
                [title]="isFilterActive(col.field) ? 'Filter applied - ' + col.header : 'Filter ' + col.header"
                (click)="openFloatingFilter($event, col.field)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-body-container">
      <cdk-virtual-scroll-viewport
        itemSize="56"
        class="virtual-scroll-viewport"
        (scrolledIndexChange)="onScrolledIndexChange($event)"
      >
        <div
          class="table-body-row"
          [ngClass]="{ 'new-row': row.isNew }"
          *cdkVirtualFor="let row of data; let i = index"
        >
          <div class="table-header-cell fixed-width-cell-2">
            <input
              type="checkbox"
              [checked]="selectedRows.includes(row)"
              (change)="toggleRowSelection(row, $event)"
            />
          </div>

          <!-- Development Area -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <select
                *ngIf="row.isNew"
                [(ngModel)]="row.devArea"
                (ngModelChange)="onDevelopmentAreaChange(row, $event)"
              >
                <option value="">-- Select Development Area --</option>
                <optgroup label="Development Areas" *ngIf="getDevAreaOptionsForRow(row).length > 0">
                  <option *ngFor="let area of getDevAreaOptionsForRow(row)" [value]="area">
                    {{ area }}
                  </option>
                </optgroup>
                <optgroup label="Sub Development Areas" *ngIf="getSubDevelopmentAreaOptionsForRow(row).length > 0">
                  <option *ngFor="let area of getSubDevelopmentAreaOptionsForRow(row)" [value]="area">
                    {{ area }}
                  </option>
                </optgroup>
              </select>
              <div *ngIf="!row.isNew" class="readonly-cell">
                {{ row.devArea || '-' }}
              </div>
            </div>
          </div>

          <!-- Alternate Capacity Plant -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <select
                *ngIf="row.isNew"
                [(ngModel)]="row.alternateCapacityPlant"
                (ngModelChange)="onFacilityNameChange(row, $event)"
              >
                <option value="">-- Select Facility Name --</option>
                <option *ngIf="getAlternateCapacityPlantOptionsForRow(row).length === 0 && row.devArea"
                value="" disabled
                >
                  No facilities available for this development area
                </option>
                <option *ngFor="let facility of getAlternateCapacityPlantOptionsForRow(row)" [value]="facility">
                  {{ facility }}
                </option>
              </select>
              <div *ngIf="!row.isNew" class="readonly-cell">
                {{ row.alternateCapacityPlant || '-' }}
              </div>
            </div>
          </div>

          <!-- Alternate Capacity Type -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <select
                *ngIf="row.isNew"
                [(ngModel)]="row.alternateCapacityType"
                (ngModelChange)="handleEdit(row)"
              >
                <option value="">-- Select --</option>
                <option *ngFor="let type of getAlternateCapacityTypeOptionsForRow(row)" [value]="type">
                  {{ type }}
                </option>
              </select>
              <div *ngIf="!row.isNew" class="readonly-cell">
                {{ row.alternateCapacityType || '-' }}
              </div>
            </div>
          </div>

          <!-- Alternate Limit Quantity -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <input
                type="number"
                [(ngModel)]="row.alternateLimitQuantity"
                (input)="validateAlternateLimit(row, $event)"
                placeholder="Enter limit quantity"
              />
            </div>
          </div>

          <!-- Effective Date -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <input
                type="date"
                [(ngModel)]="row.effectiveDate"
                (change)="handleEdit(row)"
                placeholder="YYYY-MM-DD"
              />
            </div>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>

  <div class="loading-more" *ngIf="loading">
    <div class="loading-spinner"></div>
    <span>Loading more data...</span>
  </div>

  <div
    class="floating-filter-dropdown"
    #floatingFilterPanel
    *ngIf="showFloatingFilter"
    [ngStyle]="{
      top: dropdownPosition.top + 'px',
      left: dropdownPosition.left + 'px'
    }"
  >
    <!-- Multi-select filter -->
    <ng-container *ngIf="getFilterType(activeFilter) === 'multi-select'">
      <input
        type="text"
        [(ngModel)]="filterSearch[activeFilter]"
        placeholder="Search..."
      />

      <div *ngIf="isLoadingFilterOptions" class="filter-loading">
        <div class="spinner-small"></div>
        Loading options...
      </div>

      <div *ngIf="!isLoadingFilterOptions" class="filter-options">
        <div *ngIf="getFilterOptions(activeFilter).length === 0" class="no-options">
          No options available based on current filters
        </div>
        <div class="filter-options-count" *ngIf="getFilterOptions(activeFilter).length > 0">
          {{ getFilterOptions(activeFilter).length }} options available
        </div>
        <label *ngFor="let option of getFilterOptions(activeFilter)">
          <input
            type="checkbox"
            [checked]="isChecked(activeFilter, option)"
            (change)="toggleMultiFilter(activeFilter, option, $event)"
          />
          <span>{{ option }}</span>
        </label>
      </div>

      <div class="filter-buttons">
        <button (click)="applyFilter(activeFilter)">Apply</button>
        <button (click)="clearFilter(activeFilter)">Clear</button>
      </div>
    </ng-container>

    <!-- Date range filter (for effective date) -->
    <ng-container *ngIf="getFilterType(activeFilter) === 'date-range'">
      <div class="date-range-filter">
        <label>Start Date:</label>
        <input
          type="date"
          [(ngModel)]="dateRangeFilters.startDate"
          placeholder="Start Date"
        />
        
        <label>End Date:</label>
        <input
          type="date"
          [(ngModel)]="dateRangeFilters.endDate"
          placeholder="End Date"
        />
      </div>

      <div class="filter-buttons">
        <button (click)="applyDateRangeFilter()">Apply</button>
        <button (click)="clearDateRangeFilter()">Clear</button>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #deleteConfirmDialog>
  <div class="dialog-container">
    <h2 class="dialog-title">Confirm Delete</h2>
    <div class="dialog-content">
      <p>{{ dialogMessage }}</p>
    </div>
    <div class="dialog-actions">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
      <button class="delete-button" [mat-dialog-close]="true">Delete</button>
    </div>
  </div>
</ng-template>

<ng-template #exportOptionsDialog>
  <div class="dialog-container export-dialog-container">
    <h2 class="dialog-title">Export Oil and Gas Alternate Capacities</h2>
    <div class="dialog-content export-dialog-content">
      <p>Select which data you want to download.</p>
    </div>
    <div class="export-dialog-actions">
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="exportToCSV()">Export Filtered</button>
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="downloadAllData()">Export All</button>
    </div>
    <div class="dialog-actions export-dialog-footer">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
    </div>
  </div>
</ng-template>
